import ScrollTo from './ScrollTo';
import {ScrollUpdateURI} from './ScrollTo';

export {ScrollUpdateURI,ScrollTo};
export default ScrollTo;



// WEBPACK FOOTER //
// ./src/js/_core/components/ScrollTo/index.jsx